import React from "react";
import { Grid } from "@mui/material";
import AppointmentDurationSection from "./AppointmentDurationSection";
import TimezoneSection from "./TimezoneSection";
import WorkingHoursSection from "./WorkingHoursSection";
import OutReachHoursSection from "./OutReachHoursSection";

// ---- Define prop types ----
interface AvailabilitySettingsProps {
  methods: any; // Replace with correct type from react-hook-form (e.g. UseFormReturn<any>)
  param: {
    tabType?: number;
    [key: string]: any;
  };
  showSkeleton: boolean;
  durationOptions: any[];
  durationTypeOptions: any[];
  locationData: any[];
  teamMemberLocationData: any[];
  daysOfWeek: any[];
  frequencyOptions: any[];
  outreachHospitalLocationDetailColl: any[];
  filteredAvailabilityDetailColl: any[];
  handleToggleDay: (day: string) => void;
  handleAddRow: (section: string) => void;
  handleDetailFieldChange: (
    section: string,
    field: string,
    value: any,
    index?: number
  ) => void;
  customDuration:boolean;
  setCustomDuration:boolean;
  outReachLocationData: any[];
}

// ---- Component ----
const AvailabilitySettings: React.FC<AvailabilitySettingsProps> = ({
  methods,
  param,
  showSkeleton,
  durationOptions,
  durationTypeOptions,
  locationData,
  teamMemberLocationData,
  daysOfWeek,
  frequencyOptions,
  outreachHospitalLocationDetailColl,
  filteredAvailabilityDetailColl,
  handleToggleDay,
  handleAddRow,
  handleDetailFieldChange,
  customDuration,
  setCustomDuration,
  outReachLocationData
}) => {

  if (param.tabType !== 3) return null;

  return (
    <>
      {/* Appointment Duration + Timezone + Working Hours */}
      <Grid item xs={12} className="group-container">
        <Grid container spacing={2}>
          <AppointmentDurationSection
            methods={methods}
            showSkeleton={showSkeleton}
            durationOptions={durationOptions}
            durationTypeOptions={durationTypeOptions}
            customDuration={customDuration}
            setCustomDuration={setCustomDuration}
          />

          <TimezoneSection methods={methods} showSkeleton={showSkeleton} />

          <WorkingHoursSection
            methods={methods}
            showSkeleton={showSkeleton}
            locationData={locationData}
            daysOfWeek={daysOfWeek}
            filteredAvailabilityDetailColl={filteredAvailabilityDetailColl}
            handleToggleDay={handleToggleDay}
            handleAddRow={handleAddRow}
            handleDetailFieldChange={handleDetailFieldChange}
          />
        </Grid>
      </Grid>

      {/* Outreach Hours */}
      <Grid item xs={12} className="group-container">
        <Grid container spacing={1}>
          <OutReachHoursSection
            methods={methods}
            showSkeleton={showSkeleton}
            teamMemberLocationData={teamMemberLocationData}
            daysOfWeek={daysOfWeek}
            frequencyOptions={frequencyOptions}
            outreachHospitalLocationDetailColl={
              outreachHospitalLocationDetailColl
            }
            handleToggleDay={handleToggleDay}
            handleAddRow={handleAddRow}
            handleDetailFieldChange={handleDetailFieldChange}
             durationTypeOptions={durationTypeOptions}
             outReachLocationData={outReachLocationData}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AvailabilitySettings;
